import * as actionTypes from '@actionTypes';
import { z } from 'zod';
import { UserSchema } from 'vl-common/src/schemas/shared';

export const userFetchResponse = (
  type: string,
  action: z.infer<typeof UserSchema> | null,
  token: string | null,
  isRestricted: boolean
) => ({
  type,
  user: action,
  token,
  isRestricted
});

// TODO: @Alastair Get a better type for user roles
export const userRole = (action: string | null) => ({
  type: actionTypes.AUTH_USER_SET_ROLE,
  role: action
});

export const userLogoutResponse = (error = null) => ({
  type: actionTypes.AUTH_LOGOUT_SUCCESS,
  user: null,
  token: null,
  policy: null,
  role: null,
  isRestricted: null,
  error
});
